import React from 'react';

export default function ToggleSwitch({ label = "Custom", formik }) {
  const enabled = formik?.values?.CustomPayEnbl ?? false;

  const toggleSwitch = () => {
    formik?.setFieldValue('CustomPayEnbl', !enabled);
  };

  return (
    <div className="flex items-center">
      <span className="text-sm font-light text-gray-400">{label}</span>
      <button
        type="button"
        onClick={toggleSwitch}
        className={`ml-[5px] relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
          enabled ? 'bg-blue-600' : 'bg-sky-100'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
            enabled ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
}
